(function(){

  var sharing = MW.modules.sharing;
  var storage = MW.modules.storage;
  var $body = $('body');
  var smsSeparator = (function(ua){
    var separator = (ua.match(/iPad/i) || ua.match(/iPhone/i) || ua.match(/iPod/i)) ? '&' : '?';
    return separator;
  })(navigator.userAgent);

  if (sharing.buttons[0] == "pinterest") {
    MW.modules.referrer = "pinterest";
  } else {
    if(document.referrer.indexOf(window.location.host) == -1) {
      for(var i = 0; i < sharing.buttons.length; i++) {
        var compstr = sharing.buttons[i];
        if(sharing.buttons[i] === "twitter") {
            compstr = "t.co/";
        } else if(sharing.buttons[i] === "gplus") {
          compstr = "plus.google.com";
        }
        if(document.referrer.indexOf(compstr) >= 0) {
          sharing.buttons.unshift(sharing.buttons.splice(i,1)[0]);
          MW.modules.referrer = sharing.buttons[0];
          if(storage.enabled) {
            storage.set('socialReferrer', sharing.buttons[0]);
          }
          break;
        }
      }
    }

    // prefer social button that user has clicked
    if(storage.enabled) {
      var index = sharing.buttons.indexOf(storage.get('socialReferrerClick'));
      if(index > -1) {
        MW.modules.referrer = sharing.buttons[index];
        sharing.buttons.unshift(sharing.buttons.splice(index,1)[0]);
      }
    }
  }

  if (!!MW.modules.referrer) {
    $('body').attr('data-referrer', sharing.buttons[0]);
    // var shareBar = JST["social_share"]({button: sharing.buttons[0]});
  } else {
    var shareBar = "";
  }

  var encode = encodeURIComponent;
  var trackingPixel = function(social_messaging, item) {
    ((social_messaging[item] || {}).tracking || []).forEach(function(p) {
      var a = new Image();
      a.src = p;
    });
  };

  sharing.shareItem = function(event) {
    var result = {};
    var $button = $(this);
    var type = $button.parent().attr('data-type');
    var host = location.protocol + "//" + location.host;

    var metasWithProps = $('meta').filter(function(idx, elem) {
      return $(elem).attr('property');
    });

    metasWithProps.each(function(idx, elem) {
      var $elem = $(elem);
      var propName = $elem.attr('property').replace(/\:/g, '');
      result[propName] = $elem.attr('content');
    });

    var props = {
      title: result.ogtitle,
      url: result.ogurl,
      shareUrl: result.ogurl,
      mobileUrl: location.href,
      image: result.ogimage,
      twitter: result.twittersite,
      social_messaging: result.socialmessaging || {}
    };

    switch(type) {
      case "facebook":
        $button.attr('href', "http://facebook.com/share.php?u="+props.url);
        $button.attr('target', "_blank");
        trackingPixel(props.social_messaging, 'facebook');
      break;
      case "twitter":
        var hashtags = (props.social_messaging.twitter || {}).hashtag || "";
        hashtags = hashtags.replace(/ /g, ",").replace(/#/g, "");
        $button.attr('href', "https://twitter.com/share?text="+props.title+"&url="+props.shareUrl+"&via="+props.twitter+"&hashtags="+hashtags);
        $button.attr('target', "_blank");
        trackingPixel(props.social_messaging, 'twitter');
      break;
      case "gplus":
        $button.attr('href', "http://plus.google.com/share?url="+props.url);
        $button.attr('target', "_blank");
      break;
      case "line":
        $button.attr('href', "http://line.me/R/msg/text/?"+props.title+" "+props.shareUrl);
        $button.attr('target', "_blank");
      break;
      case "whatsapp":
        sharing.whatsapp(props.title, props.shareUrl);
        event.preventDefault();
      break;
      case "kakao":
        sharing.openKakao(props.title, props.shareUrl, props.image);
        event.preventDefault();
      break;
      case "pinterest":
        $button.attr('href', "http://pinterest.com/pin/create/button/?url="+props.shareUrl+"&media="+props.image+"&description="+props.title);
        $button.attr('target', "_blank");
      break;
      case "email":
        $button.attr('target', null);
        trackingPixel(props.social_messaging, 'email');
      break;
      case "sms":
        $button.attr('href', "sms:" + smsSeparator + "body=" + encodeURIComponent(props.title + " " + props.mobileUrl));
        $button.attr('target', null);
      break;
      case "tumblr":
        $button.attr('href', "http://www.tumblr.com/share/link?url="+props.shareUrl+"&name="+props.title);
        $button.attr('target', "_blank");
      break;
      case "linkedin":
        $button.attr('href', "https://www.linkedin.com/shareArticle?mini=true&url="+props.shareUrl+"&title="+props.title+"&source=HuffingtonPost");
        $button.attr('target', "_blank");
      break;
      case "viadeo":
        $button.attr('href', "https://partners.viadeo.com/share?url="+props.shareUrl);
        $button.attr('target', "_blank");
      break;
    }
    !/(email|sms)/.test(type) && storage.enabled && storage.set('socialReferrerClick', type); // jshint ignore:line
  };

  sharing.enable = function(name) {
    var style = '<style data-from="social_bar.js">.share-list-js .' + name + '{display:inherit;}</style>';
    $(document.head).append(style);
  };

  sharing.toggleMenu = function($el) {
    $el.toggleClass('open');
  };

  sharing.addSocialToImage = function(img) {
    if(img.offsetHeight > 100 || img.naturalHeight > 100 || img.height > 100) {
      var src;
      var wrapperClass;
      var $img = $(img);
      if (!!img.src) {
        src = img.src;
      } else {
        src = img.style.backgroundImage.slice(4, -1);
      }
      var wrapper = $("<span></span>");
      if(img.align == "left" || img.align == "right") {
        wrapper.addClass(img.align);
        img.align = "";
      }
      wrapper.addClass("share-bar-image-wrapper");
      if (!img.src) {
        wrapper.addClass("share-bar-div-wrapper");
      }
      if (!($img.parent().hasClass('listicle__slide__content') || $img.hasClass('top-media__image'))) {
        wrapper.attr("data-beacon", '{"p":{"mnid":"entry_image"}}');
      }
      wrapper.data("sharingimage", src);
      // wrapper.append(shareBar);
      wrapper.insertAfter(img);
      wrapper.prepend(img);
    }
  };

  sharing.addSocial = function(container) {
    var $container = container || MW.elements.$main;

    // images
    var selectors = ['.entry-text>p>img', '.listicle__slide__content>img', '.top-media__image'];
    var $all = $container.find(selectors.join(', '));

    // insert afters
    // Only a share thing on the headline if the ab test says so
    var afterSelectors = ['header .headline__title', '.recirc__content-container', '.pane-window__entry-label'];
    var $allAfters = $container.find(afterSelectors.join(', '));

    $all.each(function(ind, img) {
      if (!img.src || img.complete) {
        sharing.addSocialToImage(img);
      }
      else {
        img.addEventListener('load', function(e) {
          sharing.addSocialToImage(e.target);
        });
      }

    });

  };

  sharing.addSocial();
  $('body').on('click', '.share-bar a', sharing.shareItem);

  var $window = $(window),
      $paneTrigger = $('.header__trigger--pane-window'),
      $mainSocialBar = $('.share-bar--bottom'),
      $shareList = $mainSocialBar.find('.share-bar__list'),
      $headerSection = $('.header__window'),
      $showMore = $('.share-bar__show-more');

  var openShareBar = 'share-bar--open';

  function toggleSocialMoreButton() {
    var socialBarWidth = $shareList.outerWidth();
    var totalWidthOfThingsInsideSocialBar = $shareList.children().outerWidth() * $shareList.children().length;

    if(socialBarWidth > totalWidthOfThingsInsideSocialBar) {
      $showMore.addClass('hidden');
    } else {
      $showMore.removeClass('hidden');
    }
  }

 toggleSocialMoreButton();
 $window.on('resize', toggleSocialMoreButton);

  $showMore.on('click', function(e) {
    e.preventDefault();
    if ($mainSocialBar.hasClass(openShareBar)) {
      Mobileweb.toggleBeacon(e.target, {"lnid": "open"});
      $mainSocialBar
        .removeClass(openShareBar)
        .height('');
    } else {
      Mobileweb.toggleBeacon(e.target, {"lnid": "close"});
      $mainSocialBar
        .addClass(openShareBar)
        .height($mainSocialBar.find('.share-bar__list').outerHeight())
      ;
    }
  });

  MW.events.subscribe('entered_entry', function($node) {
    var newData = {};
    var data = $node.data();
    Object.keys(data).forEach(function(key) {
      newData[key] = data[key];
    });
    $mainSocialBar.find('.share-list-js').data(newData);
  });

}());
